import React from "react";

type ClaimJurisdictionButtonProps = {
	// "primary" is the full-width blue button. "link" is the text button under it ("Change email").
	variant: "primary" | "link";
	type?: "button" | "submit";
	disabled?: boolean;
	onClick?: () => void;
	children: React.ReactNode;
};

/** Button of the claim screens, with the two styles of the design. */
const ClaimJurisdictionButton = ({
	variant,
	type = "button",
	disabled = false,
	onClick,
	children
}: ClaimJurisdictionButtonProps) => {
	return (
		<button
			type={type}
			disabled={disabled}
			onClick={onClick}
			className={`claim-jurisdiction-button claim-jurisdiction-button-${variant}`}
		>
			{children}
		</button>
	);
};

export default ClaimJurisdictionButton;
